import React, { Component } from 'react';
import {Widget} from '../CustomDashboards/components/index'
import { Dashboard as DashboardLayout } from '../../layouts'
import { Grid, CircularProgress } from '@material-ui/core';
import { injectIntl,  } from 'react-intl';
import { withAlert } from 'react-alert';
import hubAPI from '../../services/hubAPI';
import HUBContext from '../../services/HUBContext';

export class index extends Component {
    constructor(props){
        super(props);

        let breadcrumb = [{ 
            type: 'link', 
            to: '/customdash', 
            text: this.props.intl.formatMessage({ id: 'sharedDashboard', defaultMessage: 'Shared Dashboard' }) }];

        this.state = {
            companyID: 0,
            breadcrumb : breadcrumb,
            status: 'ready',
            sharedDashboardList: {
                data: [],
                count: 0,
                pageSize: 10,
                pageIndex: 0
            }
        }
    }

    loadSharedDashboards=()=>{
        this.setState({status : 'loading'});
        hubAPI.get(`/api/v1/Dashboard/0/share/${this.state.companyID}`).then(response =>{
            this.setState({sharedDashboardList : response.data, status : 'ready'});
        }).catch(err =>{
            this.setState({status: 'ready'})
            if (err.response) {
                switch(err.response.status) {    
                    case 400:  this.showAlert(this.props.intl.formatMessage({ id: 'badRequest', defaultMessage: 'Bad request' }));break;
                    case 403: this.showAlert(this.props.intl.formatMessage({ id: 'accessDenied', defaultMessage: 'Access denied' }));break;
                    case 404: this.showAlert(this.props.intl.formatMessage({ id: 'notFound', defaultMessage: 'The requested resource is not available' })); break;
                    default: this.showAlert(this.props.intl.formatMessage({ id: 'connectionProblem', defaultMessage: 'Connection problem'})); break;
                }
                 
             } else if (err.request) {
                this.showAlert(this.props.intl.formatMessage({ id: 'requestError', defaultMessage: 'Request error' }), 'error');
                console.log(err.request);

            } else
                this.showAlert(this.props.intl.formatMessage({ id: 'connectionError', defaultMessage: 'Connection error'}), 'error');
        })
    }

    componentDidMount(){
        this.context.setBreadCrumb(this.state.breadcrumb);
        this.setState({
            companyID : this.context.companyID,

        },()=>{
            this.loadSharedDashboards();
        })
        
    }
    componentDidUpdate(){
        if (this.state.companyID !== this.context.companyID){
           this.setState( {
               companyID: this.context.companyID

        }, () => {   
            this.loadSharedDashboards();
           });
       }    
   }
   addHistory=(element)=>{
        this.props.history.push("/dashboard/"+element);
    }   

    render() {
        if(this.state.status === 'ready'){
            return(
            <DashboardLayout title={ this.props.intl.formatMessage({ id: 'customDashboard', defaultMessage: 'Custom Dashboard' }) } >
                <Grid container spacing={1} >
                    <Widget 
                        data={this.state.sharedDashboardList} 
                        share={true}
                        addHistory={this.addHistory}
                    />
                </Grid>
            </DashboardLayout>
            )
        }
        else{
        return (
          <DashboardLayout title={ this.props.intl.formatMessage({ id: 'customDashboard', defaultMessage: 'Custom Dashboard' }) } >
                       <CircularProgress></CircularProgress>
            </DashboardLayout>
        )
        }
    }
}

index.contextType = HUBContext;
export default withAlert()(injectIntl(index))
